import { render, staticRenderFns } from "./limit-coupon-look.vue?vue&type=template&id=2022b96a&scoped=true"
import script from "./limit-coupon-look.vue?vue&type=script&lang=js"
export * from "./limit-coupon-look.vue?vue&type=script&lang=js"
import style0 from "./limit-coupon-look.vue?vue&type=style&index=0&id=2022b96a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2022b96a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2022b96a')) {
      api.createRecord('2022b96a', component.options)
    } else {
      api.reload('2022b96a', component.options)
    }
    module.hot.accept("./limit-coupon-look.vue?vue&type=template&id=2022b96a&scoped=true", function () {
      api.rerender('2022b96a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activities/components/limit-coupon-look.vue"
export default component.exports